
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/farmbook/twitter",
      function () {
        return require("private-next-pages/farmbook/twitter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/farmbook/twitter"])
      });
    }
  